import { ApiClient } from "../ApiClient";

/**
 * Fetch messages for a specific filing
 * returns: Promise<Response>
 */
export const fetchMessages = (url, filingId) => {
  // ApiClient handles baseUrl, headers, and credentials automatically
  return ApiClient.get(`${url}/${filingId}`);
};
